<template>
	<section>
		<el-dropdown @command="handleCommand" trigger="click">
			<i class="el-icon-more" style="font-size:18px;cursor: pointer;" />
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item v-if="commands.includes('remove')" command="remove">删除</el-dropdown-item>
				<el-dropdown-item v-if="commands.includes('print')" command="print">打印</el-dropdown-item>
				<el-dropdown-item v-if="commands.includes('revoke')" command="revoke">撤回审核</el-dropdown-item>
				<el-dropdown-item v-if="commands.includes('move')" command="move">移动到</el-dropdown-item>
				<!-- <el-dropdown-item v-if="commands.includes('exportPdf')" command="pdf">导出pdf</el-dropdown-item> -->
			</el-dropdown-menu>
		</el-dropdown>
		<record-print ref="recordPrintRef" />
	</section>
</template>

<script>
	import { recordApi, approveApi } from "@/boot-api/record";
	import { itemApi } from '@/boot-api/vdisk'
	import SelectFolder from '@/views/vdisk/select-folder.vue'
	import RecordMixin from '@/views/record/record-mixin'
	import RecordPrint from '@/views/record/record-print.vue'
	export default {
		components: { SelectFolder, RecordPrint },
		props: {
			docId: {
				type: Number,
				required: true
			},
			index: {
				type: Number,
				default: -1
			},
			commands: {
				type: Array,
				default: () => ['remove', 'print', 'move', 'exportPdf', 'revoke']
			},
			item: {
				type: Object,
				default: null
			}
		},
		mixins: [RecordMixin],
		data() {
			return {

			}
		},
		methods: {
			handleCommand(command) {
				if (!this[command]) {
					this.$emit(command)
				} else {
					this[command]()
				}
			},
			pdf() {
				this.exportPdf(this.docId)
			},
			remove() {
				if (this.index < 0) {
					this.$message.warning("index 必须 >=0")
					return;
				}
				this.$confirm(`确定删除实录 `, '提示').then(res => {
					recordApi.remove({ id: this.docId }).then(() => {
						this.$message.success('删除成功')
						this.$emit("remove", this.index)
					}).catch(e => console.log(e))
				}).catch(e => console.log(e))
			},
			move() {
				this.$msgbox({
					title: '移动到目录',
					showCancelButton: true,
					closeOnClickModal: false,
					beforeClose: async (action, instance, done) => {
						if (action == 'confirm') {
							instance.confirmButtonLoading = true
							const folderId = this.$refs.selectFolderRef.getSelectId()
							await itemApi.save({ fileId: this.docId, folderId, size: 0, type: 1 })
							this.$message.success('移动成功')
							instance.confirmButtonLoading = false
						}
						this.$refs.selectFolderRef.reset()
						done()
					},
					message: <select-folder ref='selectFolderRef' style='width:100%' key={this.docId} folderId={this.record.folderId} />
				})
			},
			print() {
				this.$refs.recordPrintRef.print(this.docId)
			},
			revoke() {
				approveApi.revoke({ docId: this.docId }).then(res => {
					if (res.data) {
						this.$message.success("撤销成功")
						if (this.item) {
							this.item.status = {
								code: 1,
								description: '正常'

							}
						}
					}

				})
			}


		},
	}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/views/record/record-action.vue